import { Box, Typography } from '@mui/material'
import PrimaryButton from '../common/PrimaryButton'
import HomeStoryCard from './HomeStoryCard'
import { homeLatestStories } from '../../data/homeContent'
import {
  HOME_MOBILE_MQ,
  homeMobileButtonSx,
  homeMobilePaddingX,
  homeSectionPy,
  homeSectionTitleSx,
} from './homeMobileLayout'

export default function LatestStoriesSection() {
  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        maxWidth: 1920,
        mx: 'auto',
        px: homeMobilePaddingX,
        py: homeSectionPy,
        boxSizing: 'border-box',
        minWidth: 320,
      }}
    >
      <Box sx={{ maxWidth: 1520, width: '100%', mx: 'auto', minWidth: 0 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'center' },
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 3, md: 2 },
            mb: { xs: '32px', md: '60px', lg: '80px' },
            [HOME_MOBILE_MQ]: { mb: '32px' },
          }}
        >
          <Typography
            component="h2"
            sx={{
              ...homeSectionTitleSx,
              [HOME_MOBILE_MQ]: { fontSize: 28 },
            }}
          >
            Latest Stories
          </Typography>
          <PrimaryButton
            to="/stories"
            showArrow={false}
            sx={{
              display: { xs: 'none', md: 'inline-flex' },
            }}
          >
            See All Stories
          </PrimaryButton>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: 'minmax(0, 1fr)',
              md: 'repeat(2, minmax(0, 1fr))',
              lg: 'repeat(3, minmax(0, 1fr))',
            },
            columnGap: { xs: 0, md: '32px', lg: '40px' },
            rowGap: { xs: '32px', md: '36px', lg: '40px' },
            alignItems: 'start',
            width: '100%',
            [HOME_MOBILE_MQ]: {
              gridTemplateColumns: 'minmax(0, 1fr)',
              rowGap: '32px',
            },
          }}
        >
          {homeLatestStories.map((story) => (
            <HomeStoryCard key={story.slug} {...story} to={`/stories/${story.slug}`} />
          ))}
        </Box>

        <Box
          sx={{
            display: 'none',
            justifyContent: 'center',
            mt: '32px',
            [HOME_MOBILE_MQ]: { display: 'flex' },
          }}
        >
          <PrimaryButton to="/stories" showArrow={false} sx={homeMobileButtonSx}>
            See All Stories
          </PrimaryButton>
        </Box>
      </Box>
    </Box>
  )
}
